import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuiviModule } from 'src/app/features/suivi/suivi.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, SuiviModule],
})
export class ActionSuivisModule {}
